import { immerable } from 'immer';

interface IPicEntity {
	id: number;
	label: string;
	dataUrl: string;
	isNew: boolean;
}

const entityDefaults: IPicEntity = {
	id: -1,
	label: '',
	dataUrl: '',
	isNew: false,
};

export class PicEntity implements IPicEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public label = entityDefaults.label;
	public dataUrl = entityDefaults.dataUrl;
	public isNew = entityDefaults.isNew;

	public static build(params: Partial<IPicEntity> = {}): PicEntity {
		const entity = new PicEntity();
		entity.id = params.id ?? entityDefaults.id;
		entity.label = params.label ?? entityDefaults.label;
		entity.dataUrl = params.dataUrl ?? entityDefaults.dataUrl;
		entity.isNew = params.isNew ?? entityDefaults.isNew;
		return entity;
	}

	private constructor() {}
}
